var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGateCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 22.6264 39.4827 25.2272 38.4776 27.6537C37.4725 30.0802 35.9993 32.285 34.1421 34.1421C32.285 35.9993 30.0802 37.4725 27.6537 38.4776C25.2272 39.4827 22.6264 40 20 40V20H40Z",
    fill: "#005857"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C17.3736 40 14.7728 39.4827 12.3463 38.4776C9.91982 37.4725 7.71503 35.9993 5.85786 34.1421C4.00069 32.285 2.5275 30.0802 1.52241 27.6537C0.517315 25.2272 -2.2961e-07 22.6264 0 20L20 20V40Z",
    fill: "#A90821"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C4.63719e-07 14.6957 2.10714 9.60859 5.85786 5.85786C9.60859 2.10714 14.6957 -6.32535e-08 20 0V20L0 20Z",
    fill: "#FC9D2C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0C22.6264 3.132e-08 25.2272 0.517315 27.6537 1.52241C30.0802 2.5275 32.285 4.00069 34.1421 5.85787C35.9993 7.71504 37.4725 9.91982 38.4776 12.3463C39.4827 14.7728 40 17.3736 40 20L20 20V0Z",
    fill: "#007A9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGateCircle);
export default __webpack_public_path__ + "static/media/GateCircle.c40b92b8.svg";
export { ForwardRef as ReactComponent };